// Photos page — add, remove, or reorder entries freely.
// src: path relative to /public  |  w/h: pixel dims (drives aspect ratio)
const photos = [
  { src: '/photos/dsc09725-1.jpg', w: 1800, h: 1200 },
  { src: '/photos/adam.botma-1-57.jpg', w: 1013, h: 1800 },
  { src: '/photos/dsc06834.jpg', w: 1200, h: 1800 },
  { src: '/photos/beachdays-1.jpg', w: 1800, h: 1013 },
  { src: '/photos/dsc06801.jpg', w: 1200, h: 1800 },
  { src: '/photos/waimea-1-5.jpg', w: 1800, h: 802 },
  { src: '/photos/new-26.jpg', w: 1200, h: 1800 },
  { src: '/photos/dsc07136.jpg', w: 1800, h: 1200 },
  { src: '/photos/trees-1022.jpg', w: 1234, h: 1800 },
  { src: '/photos/palms-1-2.jpg', w: 1800, h: 1200 },
  { src: '/photos/img_0064-edit.jpg', w: 1350, h: 1800 },
  { src: '/photos/hollywood-1-2.jpg', w: 1800, h: 1106 },
  { src: '/photos/dsc06884.jpg', w: 1200, h: 1800 },
  { src: '/photos/ayla-1-5.jpg', w: 1800, h: 1200 },
  // { src: '/photos/beachdays-1-5.jpg',           w: 1800, h: 1226 },
  { src: '/photos/adam.botma-1-27.jpg', w: 1200, h: 1800 },
  // { src: '/photos/nellie-1-160.jpg',            w: 1800, h: 1163 },
  { src: '/photos/dsc00116-1.jpg', w: 1200, h: 1800 },
  { src: '/photos/dsc09275-1.jpg', w: 1800, h: 1200 },
  { src: '/photos/adz-2021-06403.jpg', w: 1800, h: 1106 },
  { src: '/photos/new-18.jpg', w: 1440, h: 1800 },
  { src: '/photos/dsc06818.jpg', w: 1800, h: 1200 },
  { src: '/photos/late-night-vibes-1-1-4.jpg', w: 1800, h: 1013 },
  // { src: '/photos/brook-1-10.jpg',              w: 1800, h: 1013 },
  { src: '/photos/dsc06921.jpg', w: 1800, h: 1200 },
  { src: '/photos/img_0048-edit.jpg', w: 1800, h: 1350 },
  { src: '/photos/adam.botma-1-23.jpg', w: 1013, h: 1800 },
  { src: '/photos/dsc09371-1.jpg', w: 1800, h: 1200 },
  { src: '/photos/dsc07098-2.jpg', w: 1800, h: 1200 },
  // { src: '/photos/nora-1-89.jpg',               w: 1800, h: 1200 },
  // { src: '/photos/beachdays-1-copy.jpg',        w: 1800, h: 1155 },
  { src: '/photos/palmyset-8.jpg', w: 1800, h: 1198 },
  { src: '/photos/gptempdownload-26-1-3.jpg', w: 1800, h: 1350 },
  { src: '/photos/dsc09452-1.jpg', w: 1800, h: 1106 },
  { src: '/photos/late-night-vibes-darth-1-1-3.jpg', w: 1800, h: 721 },
  { src: '/photos/000221110002.jpg', w: 1800, h: 1193 },
  { src: '/photos/img033-copy.jpg', w: 1800, h: 1440 },
  { src: '/photos/dsc06869.jpg', w: 1800, h: 1106 },
  { src: '/photos/new-30.jpg', w: 1800, h: 1440 },
  { src: '/photos/adam.botma-1-49.jpg', w: 1800, h: 1200 },
  { src: '/photos/img087.jpg', w: 1800, h: 1157 },
  { src: '/photos/dsc07312.jpg', w: 1800, h: 1013 },
  { src: '/photos/001.jpg', w: 1800, h: 1350 },
  { src: '/photos/palmy2.jpg', w: 1800, h: 1198 },
  { src: '/photos/img116-copy.jpg', w: 1800, h: 1166 },
  { src: '/photos/adam.botma-1-copy.jpg', w: 1800, h: 1106 },
  { src: '/photos/dsc06884.jpg', w: 1200, h: 1800 },
  { src: '/photos/file-sep-03,-6-30-53-am.jpg', w: 1800, h: 1137 },
]

export default photos
